import { render, staticRenderFns } from "./MusicEdit.vue?vue&type=template&id=f5ce460c&scoped=true&"
import script from "./MusicEdit.vue?vue&type=script&lang=ts&"
export * from "./MusicEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MusicEdit.vue?vue&type=style&index=0&id=f5ce460c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ce460c",
  null
  
)

export default component.exports